export default "__VITE_ASSET__Bzloc638__"